import React from 'react';
import dayjs from 'dayjs';
import { Alert } from 'antd';

import styles from './AlertBar.module.less';

export type EstimateAlertBarProps = {
  estimate: { status: string; validityDate: any };
};

function EstimateAlertBar(props: EstimateAlertBarProps) {
  let alertElement: any | null;

  if (props.estimate.status === 'ACCEPTED') {
    alertElement = (
      <Alert
        className={styles.alert}
        message='Dieses Angebot wurde angenommen'
        type='success'
        showIcon
      />
    );
  } else if (props.estimate.status === 'DECLINED') {
    alertElement = (
      <Alert
        className={styles.alert}
        message='Dieses Angebot wurde abgelehnt'
        type='error'
        showIcon
      />
    );
  } else {
    let message;
    let type;

    const today = dayjs().format('YYYY-MM-DD');

    if (dayjs(today).isSame(props.estimate.validityDate)) {
      message = 'Dieses Angebot läuft heute ab';
      type = 'info';
    } else if (dayjs(today).add(1, 'days').isSame(props.estimate.validityDate)) {
      message = 'Dieses Angebot läuft morgen ab';
      type = 'info';
    } else if (dayjs(today).isAfter(props.estimate.validityDate)) {
      message = 'Dieses Angebot ist abgelaufen';
      type = 'error';
    } else {
      const validityDate = dayjs(props.estimate.validityDate).add(1, 'days');
      const now = dayjs();
      message = 'Dieses Angebot ist noch ' + validityDate.diff(now, 'days') + ' Tage gültig';
      type = 'info';
    }

    alertElement = <Alert className={styles.alert} message={message} type={type} showIcon />;
  }

  return alertElement;
}

export default React.memo(EstimateAlertBar, function areEqual(prevProps, nextProps) {
  return JSON.stringify(prevProps) === JSON.stringify(nextProps);
});
